// extracted by mini-css-extract-plugin
export default {"header":"vdP7vp","title":"Rtx7Ls","subtitle":"WF7rCH","statusRow":"rtzANH"};